import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { AdminApiService } from './admin.api.service';
import { Company } from '../../models/company';
import { User } from '../../models/user';

@Injectable()
export class AdminDomainService {

    constructor(private adminApiService: AdminApiService) { }

    getCompanies(): Observable<{} | Company[]> {
        return this.adminApiService.getCompanies();
    }

    getCurrentCompany(companyId: string): Observable<{} | Company> {
        return this.adminApiService.getCurrentCompany(companyId);
    }

    createCompany(company: Company): Observable<{}> {
        return this.adminApiService.createCompany(company);
    }

    updateCompany(company: Company): Observable<{} | boolean> {
        return this.adminApiService.updateCompany(company);
    }

    deleteCompany(companyId: string, deleteToken: string): Observable<{} | boolean> {
        return this.adminApiService.deleteCompany(companyId, deleteToken);
    }

    getUsersForCompany(companyId: string): Observable<{} | User[]> {
        return this.adminApiService.getUsersForCompany(companyId);
    }

    createUser(user: Partial<User>, companyId: string): Observable<{} | boolean> {
        return this.adminApiService.createUser(user, companyId);
    }

    updateUser(user: User): Observable<{} | boolean> {
        return this.adminApiService.updateUser(user);
    }

    deleteUser(companyId: string, userId: string): Observable<{} | boolean> {
        return this.adminApiService.deleteUser(companyId, userId);
    }

    getImpersonationToken(userId: string, companyId: string): Observable<{} | any> {
        return this.adminApiService.getImpersonationToken(userId, companyId);
    }

    getCurrentUserInfo(): Observable<{} | User> {
        return this.adminApiService.getCurrentUserInfo();
    }

    updateUsername(userName: string): Observable<{} | boolean> {
        return this.adminApiService.updateUsername(userName);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/admin/admin.domain.service.ts